$(document).ready(function(){
  if(window.location.href.includes("/products/")){

    // NC Phase 13 (2026-10-19): secondary imagery back in the mobile/desktop gallery.
    // Rule: exact variant packshots first, then media tagged "on body"/"model" — SKU-tagged
    // ones only when they match the selected variant's SKU, untagged model shots always.
    function nc_extra_images(product_id){
      var sel = $('#product-form-'+product_id+' select[name=id] option:selected');
      var nc_sku = (sel.data('sku')||'').toString().toUpperCase();
      var all_skus = $('#product-form-'+product_id+' select[name=id] option').map(function(){
        return ($(this).data('sku')||'').toString().toUpperCase();
      }).get().filter(Boolean);
      return $('#select-product-images--'+product_id+' option').filter(function(){
        var a = ($(this).data('alt')||'').toString();
        if(!/on body|model/i.test(a)) return false;
        var tagged = null;
        for(var i=0;i<all_skus.length;i++){
          if(all_skus[i] && a.toUpperCase().indexOf(all_skus[i]) > -1){ tagged = all_skus[i]; break; }
        }
        return tagged ? (nc_sku && tagged === nc_sku) : true;
      });
    }

    function add_swatch_images(stone_type,metal,product_id){

      var images = stone_type +" | "+ metal;

      var images = $('#select-product-images--'+product_id+' option[data-image-handleize-alt="'+images+'"]'),
          enable_product_lightbox = $("#hidden-element--"+product_id).data("enable_product_lightbox"),
          zoom = $("#hidden-element--"+product_id).data("zoom"),
          template = $("#hidden-element--"+product_id).data("template"),
          autoplay = $("#hidden-element--"+product_id).data("autoplay"),
          div_class = $(".product-"+product_id+"-gallery").attr("class"),
          class_array = div_class.split(" ");
      	  class_array.splice($.inArray("flickity-enabled", class_array), 1),
          class_array.splice($.inArray("is-draggable", class_array), 1);
      var div_classes = class_array.join(" ");

      // NC Phase 13: packshots first, then the relevant on-body / model shots.
      // Most catalog media carry EMPTY alts (no "Color | Metal" coding), so the exact-match
      // query finds nothing on those products. In that case we must NOT rebuild the gallery
      // (we would lose the theme's correct variant packshot) — we only APPEND the secondary
      // imagery to whatever the theme is showing. Full rebuild happens only when a coded
      // packshot was found.
      var nc_extras_found = nc_extra_images(product_id).toArray();
      var nc_append_only = (images.length === 0);
      var nc_list = images.toArray();
      $(nc_extras_found).each(function(){
        if(nc_list.indexOf(this) === -1) nc_list.push(this);
      });
      if(nc_append_only){
        if(nc_extras_found.length === 0) return;
        var $gal = $(".product-"+product_id+"-gallery");
        if(!$gal.length) return;
        // drop extras appended for a previously selected variant
        $gal.find('.nc-extra').remove();
        // skip extras already present in the gallery (by image id)
        var present = {};
        $gal.find('img[data-image-id]').each(function(){ present[$(this).data('image-id')] = 1; });
        var add_html = '';
        $(nc_extras_found).each(function(){
          if(present[$(this).data('image-id')]) return;
          var w = $(this).data("width"), h = $(this).data("height"),
              u = $(this).data("image-url"), a = $(this).data("alt"),
              iid = $(this).data("image-id"), idx = $(this).data('index');
          add_html += '<div class="gallery-cell nc-extra" data-alt="'+a+'" data-title="'+a+'" data-image-height="'+h+'" data-image-width="'+w+'">'
                   +  '<div class="image__container" style="max-width:'+w+'">'
                   +  '<img src="'+u+'" alt="'+a+'" class=" lazyload fade-in" data-index="'+idx+'" data-image-id="'+iid+'" data-sizes="auto" data-src="'+u+'" />'
                   +  '</div></div>';
        });
        if(!add_html) return;
        try { if($gal.data('flickity')) $gal.flickity('destroy'); } catch(e){}
        $gal.removeClass('single-image').addClass('multi-image').append(add_html);
        $gal.flickity({
          "adaptiveHeight": true, "wrapAround": "true", "cellAlign": "left",
          "draggable": true, "contain": true, "imagesLoaded": true, "lazyLoad": 2,
          "pageDots": false, "prevNextButtons": true,
          "autoPlay": $gal.data('autoplay') ? 6000 : false,
          "selectedAttraction": 0.01, "friction": 0.15
        });
        return;
      }

      if(nc_list.length > 0){
      var Image_array = [];
      $(nc_list).each(function(i){
        var height = $(this).data("height"),
            index = $(this).data('index'),
            width = $(this).data("width"),
            image_url = $(this).data("image-url"),
            title = $(this).data("stone-type"),
            alt = $(this).data("alt"),
            image_id = $(this).data("image-id"),
            data_metal = $(this).data("metal"),
            loading_style = "fade-in";

            var sizes = "auto";
        if(enable_product_lightbox == true){
          sizes="100vw";
        }

        var image_html = '<div class="gallery-cell" data-alt="'+alt+'" data-title="'+alt+'" data-image-height="'+height+'" data-image-width="'+width+'">';
        if(template != 'index' && enable_product_lightbox == true){
          image_html += '<a href="'+image_url+'" class="lightbox" rel="gallery" data-fancybox-group="gallery" data-lightbox-zoom="'+zoom+'">';
        }
        image_html += '<div class="image__container" style="max-width:'+width+'">';
        image_html += '<img src="'+image_url+'"  alt="'+alt+'" class=" lazyload '+loading_style+'" data-index="'+index+'" data-image-id="'+image_id+'" data-sizes="'+sizes+'" data-handleize-alt="'+data_metal+'" data-src="'+image_url+'" />';

        image_html += '</div>';
        if(template != 'index' && enable_product_lightbox == true){
          image_html += '</a>';
        }
        image_html += '</div>';

        Image_array.push(image_html);
      });

      var final_html = '<div class="'+class_array.join(" ")+'" data-zoom="'+zoom+'" data-autoplay="'+autoplay+'">';
      final_html += Image_array.join(" ");
      final_html += '</div>';

      $(".product-"+ product_id +"-gallery").replaceWith(final_html);

      var draggable = true;
      var prevNextButtons = true;
      var autoplay = $('.product_gallery').data('autoplay');

      if ($('.product_gallery').hasClass('single-image')){
        draggable = false;
        prevNextButtons = false;
      }

      
      //used for settings.slideshow_arrow_size === 'regular'
      var arrowSize = {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
      

      $('.product_gallery').flickity({
        "adaptiveHeight": true,
        "wrapAround": "true",
        "cellAlign": "left",
        "draggable": draggable,
        "contain": true,
        "imagesLoaded": true,
        "lazyLoad": 2,
        "pageDots": false,
        "prevNextButtons": prevNextButtons,
        "autoPlay": autoplay ? 6000 : false,
        "selectedAttraction": 0.01,
        "friction": 0.15,
        "arrowShape": arrowSize
      });

        }
    }

    $(document).on("click",".swatch_options [name='option-0']",function(){
      var stone_type = $(this).data("handleize-value"),
          product_id = $(this).data("product-id"),
          selected_metal = $('[name="option-1"]:checked').data("handleize-value");

      add_swatch_images(stone_type,selected_metal,product_id);

    });

      $(document).on("click",".swatch_options [name='option-1']",function(){
      var metal = $(this).data("handleize-value"),
          product_id = $(this).data("product-id"),
          selected_stone_type = $('[name="option-0"]:checked').data("handleize-value");

        add_swatch_images(selected_stone_type,metal,product_id);

    });

    $(document).on("click",".swatch_options [name='option-1']",function(){
      var handleize_value = $(this).data("handleize-value");
      var varinat_image = $(".product_gallery .gallery-cell .image__container img[data-handleize-alt='"+handleize_value+"']");
      if(varinat_image.length == 1){
        var image_index = varinat_image.data("index");
        var $slider = $('.product_gallery');
        $slider.flickity( 'select', parseInt(image_index), false, true);
      }
    });

    // NC Phase 13: rebuild the gallery once on load so secondary imagery is present
    // from the first paint, not only after a swatch tap. The theme checks the swatch
    // radios asynchronously (?variant= URLs), so retry until they are selected.
    var nc_boot_tries = 0;
    var nc_boot = function(){
      nc_boot_tries++;
      var st = $('.swatch_options [name="option-0"]:checked'),
          mt = $('.swatch_options [name="option-1"]:checked');
      if(st.length && mt.length && st.data('product-id')){
        add_swatch_images(st.data('handleize-value'), mt.data('handleize-value'), st.data('product-id'));
      } else if(nc_boot_tries < 8){
        setTimeout(nc_boot, 350);
      }
    };
    // run after the theme's own gallery init has settled, with one safety re-check
    setTimeout(nc_boot, 900);
    setTimeout(function(){
      if($('.product_gallery .gallery-cell').length <= 1){ nc_boot_tries = 0; nc_boot(); }
    }, 2600);

    // after any swatch tap, the theme's own variant-gallery swap can land after ours;
    // one-shot check restores the secondary imagery if it was overwritten.
    var nc_ensure = function(){
      setTimeout(function(){
        var st = $('.swatch_options [name="option-0"]:checked'),
            mt = $('.swatch_options [name="option-1"]:checked');
        if(!st.length || !mt.length) return;
        var pid = st.data('product-id');
        if(!pid) return;
        var want = nc_extra_images(pid).length;
        var has = $('.product_gallery .gallery-cell').filter(function(){
          return /on body|model/i.test($(this).data('alt') || '');
        }).length;
        if(want > 0 && has === 0){
          add_swatch_images(st.data('handleize-value'), mt.data('handleize-value'), pid);
        }
      }, 1100);
    };
    $(document).on('click', '.swatch_options input', nc_ensure);

    // NC Phase 13: mobile sticky buy bar — appears when the inline Add to Cart leaves the viewport.
    if(window.matchMedia('(max-width:798px)').matches && $('.product_form .add_to_cart').length){
      var $nc_atc = $('.product_form .add_to_cart').first();
      var $nc_bar = $('<div class="nc-sticky-atc"><div class="nc-sticky-meta"><div class="nc-sticky-price"></div><div class="nc-sticky-variant"></div></div><button type="button">Add to Cart</button></div>');
      $('body').append($nc_bar);
      var nc_sync = function(){
        $nc_bar.find('.nc-sticky-price').text($('.product_section .modal_price').first().text().trim().split('\n')[0]);
        var opts = $('.swatch .selected_variant_color').map(function(){ return $(this).text().trim(); }).get().filter(Boolean).join(' · ');
        $nc_bar.find('.nc-sticky-variant').text(opts);
      };
      nc_sync();
      $(document).on('click','.swatch_options input',function(){ setTimeout(nc_sync, 200); });
      $nc_bar.find('button').on('click',function(){ $nc_atc.trigger('click'); });
      var nc_onscroll = function(){
        if(!$nc_atc.length || !$nc_atc[0].isConnected){ $nc_atc = $('.product_form .add_to_cart').first(); if(!$nc_atc.length) return; }
        var r = $nc_atc[0].getBoundingClientRect();
        $nc_bar.toggleClass('nc-on', r.bottom < 0 || r.top > window.innerHeight);
      };
      $(window).on('scroll resize', nc_onscroll);
      nc_onscroll();
    }

  }
});
